let cinemaParralax = document.querySelector('.mouseparallax')

if (!(('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)) && cinemaParralax) {
	cinemaParralax.addEventListener('mousemove', e => {
		let x = e.clientX / 70
		var y = e.clientY / 70

		let stars = document.querySelectorAll('.cinema__star')

		stars.forEach(el => {
			let speed = el.getAttribute('data-mouseparallax-speed')
			let x2 = x * speed
			let y2 = y * speed

			el.style.transform = 'translate(-' + x2 + 'px, -' + y2 + 'px)'
		});

		let cds = document.querySelectorAll('.cinema__cd--fill')

		cds.forEach(el => {
			let speed = el.getAttribute('data-mouseparallax-speed')
			let x2 = x * speed
			let y2 = y * speed

			let span = el.children[0]
			let div = el.children[1]

			span.style.transform = 'translate(-' + x2 + 'px, -' + y2 + 'px)'
			div.style.transform = 'translate(-' + x2 * 1.5 + 'px, -' + y2 * 1.5 + 'px)'
		});

	})
}
